import STORE_CONSTANTS from '../../utils/store-constants'
import BRAND_CONSTANTS from './brands-constants'

export default () => {
  return {
    [STORE_CONSTANTS.ALL_IDS]: [],
    [STORE_CONSTANTS.BY_ID]: {},
    [BRAND_CONSTANTS.BY_PIM_ID]: {},
  }
}
